module.exports = __webpack_public_path__ + "static/media/9.a3ceda3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/9.png
// module id = 1106
// module chunks = 0